import { render, staticRenderFns } from "./ContentTypeContact.vue?vue&type=template&id=6caddbfe&scoped=true&"
import script from "./ContentTypeContact.vue?vue&type=script&lang=js&"
export * from "./ContentTypeContact.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeContact.vue?vue&type=style&index=0&id=6caddbfe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6caddbfe",
  null
  
)

export default component.exports